import { useCallback, useEffect, useState } from "react";
import { api } from "./api";

export function useFetch(url, deps = []) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const reload = useCallback(async () => {
    if (!url) return;
    setLoading(true);
    try {
      const r = await api.get(url);
      setData(r.data);
    } finally {
      setLoading(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [url, ...deps]);
  useEffect(() => {
    reload();
  }, [reload]);
  return { data, loading, reload, setData };
}

export function usePaged(url, params = {}, pageSize = 25) {
  const [page, setPage] = useState(1);
  const [data, setData] = useState(null);
  const key = JSON.stringify(params);
  useEffect(() => { setPage(1); }, [key, url]);
  const reload = useCallback(async () => {
    if (!url) return;
    const r = await api.get(url, { params: { ...JSON.parse(key), page, page_size: pageSize } });
    if (r.data.page > 1 && !r.data.items.length) setPage(r.data.pages);
    else setData(r.data);
  }, [url, key, page, pageSize]);
  useEffect(() => { reload(); }, [reload]);
  return { data, items: data?.items ?? null, page, setPage, reload };
}

export const useUsers = () => useFetch("/users");
export const useClientsList = () => useFetch("/clients");
